import { mockSummary } from '@/lib/demo-data/company-summary';
import { useApi } from './useApi';
import { useModeAwareQuery } from './useModeAwareQuery';

export interface CompanySummary {
  totalCompanies: number;
  activeIntegrations: number;
  activeUsers: number;
  documentTemplates: number;
}

/**
 * Hook to fetch company summary counts for the Settings-Company page metric cards.
 * Respects demo/live mode - uses mock data in demo mode, API in live mode.
 */
export function useCompanySummary() {
  const { apiGet } = useApi();

  return useModeAwareQuery<CompanySummary, Error>(
    ['company-summary'],
    async ({ signal }) => {
      return apiGet<CompanySummary>('/api/v1/company/summary', undefined, signal);
    },
    mockSummary,
    {
      staleTime: 0,
      refetchOnMount: 'always',
    },
  );
}
